import styled from "styled-components";
import theme from "~/styles/theme";

export const FAQTitle = styled.h1`
  color: ${theme.palette.neutral.primary.key};
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;
  font-family: ${theme.typography.fontFamily};
  margin-bottom: 14px;
  padding: 40px 0 24px;
  text-align: center;
  width: 100%;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 80px 0 40px;
    font-size: 40px;
  }
`;

export const FAQText = styled.p`
  color: ${theme.palette.neutral.primary.key};
  font-size: 14px;
  text-align: center;
`;

export const BgBackground = styled.div`
  background-color: #b1dbf0;

  @media (min-width: ${theme.breakpoints.values.md}px) {
  }
`;
